<template>
    <div class="col-md-4">
        <article class="room">
            <figure>
                <div class="price" v-if="room.price"> ${{ room.price || 0 }} <span>/ <span v-lang.night></span></span></div>
                <router-link class="hover_effect h_blue h_link" v-bind:to="'/site/room/'+room.id">
                    <img v-bind:src="image" class="img-responsive" alt="Image">
                </router-link>
                <figcaption>
                    <h4>
                        <router-link v-bind:to="'/site/room/'+room.id" >{{ room.name[currentLanguage] }}</router-link>
                    </h4>
                    <span class="f_right">
                        <router-link v-bind:to="'/site/room/'+room.id" class="button btn_sm btn_blue uppercase" v-lang.view_details></router-link>
                    </span>
                </figcaption>
            </figure>
        </article>
    </div>
</template>
<script>
    let _ = require('lodash');
    export default {
        props : ['room'],
        created : function(){
            let self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
            });
        },
        computed : {
            currentLanguage : function(){
                return this.$language;
            },
            image : function()
            {
                if( 'gallery' in this.room && 'photos' in this.room.gallery )
                {
                    return this.room.gallery.photos[0].large;
                }
                return `/assets/ceo/roomTypes/${this.room.id}/thumb.jpg`;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// favoriteRoom.vue?41f60e73